import { FeaturesBonusProgram } from '@travel/icons/features';
import { useDeviceType, MOBILE_SCREEN } from '@travel/traveler-core/hooks';
import useDialogHandler from '@travel/traveler-core/hooks/useDialogHandler';

import styles from './bonusProgram.module.scss';

const BonusProgram = () => {
  const { isOpen: showPopup, onOpen, onClose, onToggle } = useDialogHandler(false);

  const deviceType = useDeviceType();
  const isSP = deviceType === MOBILE_SCREEN;

  const handleInteraction = () => {
    if (isSP) {
      onToggle();
    }
  };

  const handleMouseEnter = () => {
    if (!isSP) {
      onOpen();
    }
  };

  const handleMouseLeave = () => {
    if (!isSP) {
      onClose();
    }
  };

  return (
    <div className={styles.bonusProgram}>
      <FeaturesBonusProgram
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleInteraction}
      />
      {showPopup && (
        <div className={styles.popupContainer}>
          <div className={styles.popupTriangle}></div>
          <p className={styles.popupContent}>
            こちらの宿泊施設は楽天トラベルボーナスプログラム対象で、お客様の
            <span className={styles.popupStrong}>国内宿泊回数に応じてポイントアップ</span>
            が適用されます。
            <p className={styles.popupAdditional}>
              また楽天トラベルへサービス利用料を支払うことにより、原則同条件の他の施設よりも上位に表示されています。
            </p>
          </p>
        </div>
      )}
    </div>
  );
};

export default BonusProgram;
